import { render } from "./ZoomCenterTransition.vue?vue&type=template&id=8a89b872"
import script from "./ZoomCenterTransition.vue?vue&type=script&lang=js"
export * from "./ZoomCenterTransition.vue?vue&type=script&lang=js"

import "./ZoomCenterTransition.vue?vue&type=style&index=0&id=8a89b872&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__